import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createFraseService,
  getFraseByIdService,
  getFrasesService,
  toggleFraseActiveService,
  updateFraseService,
  getTalentosSelectoresService,
} from "../../../services/frases/frases.service";

export const getFrasesThunk = createAsyncThunk(
  "frases/getAll",
  async ({ page = 1, search = "", talento = "", isRandom = "" } = {}, { rejectWithValue }) => {
    try {
      return await getFrasesService(page, search, talento, isRandom);
    } catch (error) {
      if (error.response?.status === 404) {
        return rejectWithValue("Página no válida");
      }
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener frases";

      return rejectWithValue(message);
    }
  }
);

export const createFraseThunk = createAsyncThunk(
  "frases/create",
  async (payload, { rejectWithValue }) => {
    try {
      return await createFraseService(payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al crear frase";

      return rejectWithValue(message);
    }
  }
);

export const getFraseByIdThunk = createAsyncThunk(
  "frases/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getFraseByIdService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener frase";

      return rejectWithValue(message);
    }
  }
);

export const updateFraseThunk = createAsyncThunk(
  "frases/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateFraseService(id, payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al actualizar frase";

      return rejectWithValue(message);
    }
  }
);

export const toggleFraseActiveThunk = createAsyncThunk(
  "frases/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      return await toggleFraseActiveService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al cambiar estado";

      return rejectWithValue(message);
    }
  }
);

export const getTalentosSelectoresThunk = createAsyncThunk(
  "frases/getTalentosSelectores",
  async (search = "", { rejectWithValue }) => {
    try {
      return await getTalentosSelectoresService(search);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener talentos";

      return rejectWithValue(message);
    }
  }
);
